import './new-attachment-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateAttachmentType } from "@core/query/attachment-type.query";
import { AttachmentTypeFormRule, AttachmentTypeFormSchema } from "@core/form/form.rule";
import { attachmentTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormAttachmentType from "../form-attachment-type/form-attachment-type";

export function NewAttachmentType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateAttachmentType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New AttachmentType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addAttachmentType, isLoading: isCreating } =
    useQyCreateAttachmentType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<AttachmentTypeFormSchema>({
    defaultValues: attachmentTypeFormDefault,
    resolver: zodResolver(AttachmentTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: AttachmentTypeFormSchema) => {
    const formData = mapCreateAttachmentType(form);
    addAttachmentType(formData);
  };
  const handleValidateError = (err: FieldErrors<AttachmentTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="AttachmentType" className="attachment-type">
      <HeaderContent
        title="New Attachment Type"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormAttachmentType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewAttachmentType;